import { FC } from 'react'

import { BoxContent, ErrorBox, ErrorTitle, FallbackProps } from './defaultErrorBoundaries'
import ErrorRecoveryActions from './ErrorRecoveryActions'

export type TimeoutErrorProps = FallbackProps & {
  operation?: string
  reset: () => void
}

const DefaultTimeoutErrorFallback: FC<TimeoutErrorProps> = ({ className, operation, reset }) => (
  <ErrorBox $type='warning' className={className}>
    <ErrorTitle>Timed out</ErrorTitle>
    <BoxContent>{operation ? `This request has timed out: ${operation}. ` : 'A request has timed out. '}</BoxContent>
    <ErrorRecoveryActions onRetry={reset} />
  </ErrorBox>
)

export default DefaultTimeoutErrorFallback
